import jwt_decode from "jwt-decode";
import httpClient from "../../config/httpClient";
import { httpSmartClient } from "../../config/httpClient";
import loggedStore from "../stores/LoggedStore";
import chatStore from "../stores/ChatStore";

const baseName = "Access";

const AuthService = {
  signIn: async (email, password) => {
    try {
      const response = await httpClient.post(`/${baseName}/SignIn`, { email, password });
      if (response) {
        if (response.status === 200) {
          loggedStore.UpdateCurrentUser(response.data.token);
          return response.data;
        }
      }
    } catch (error) {
      console.log(error);
      return error;
    }
  },

  signUp: async (data) => {
    try {
      const response = await httpClient.post(`/${baseName}/SignUp`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response;
    } catch (error) {
      return error;
    }
  },

  signOut: () => {
    chatStore.resetChatStore();
    loggedStore.RemoveCurrentUser();

  },

  getCurrentUser: () => {
    const token = localStorage.getItem("token");
    if (token) {
      const decoded = jwt_decode(token);
      if (decoded) {
        return decoded;
      }
    }
    return null;
  },

  sendEmail: async (email) => {
    try {
      const response = await httpSmartClient.post(`/${baseName}/AddResetPasswordRequest`, { email });

      if (response.data) {
        return true;
      } else {
        return null;
      }
    } catch {
      return null;
    }
  },
  isTokenvalid: async (token) => {
    try {
      const response = await httpSmartClient.get(`/${baseName}/IsTokenValid?token=${token}`);
      if (response.data) {
        return true;
      } else {
        return false;
      }
    } catch {
      return false;
    }
  },
  verifyEmail: async (token) => {
    var response = await httpSmartClient.get(`/${baseName}/VerifyEmail?token=${token}`);
    return response;
  },
  addVerifyPhoneNumberRequest: async () => {
    var response = await httpSmartClient.post(`/${baseName}/AddVerifyPhoneNumberRequest`);
    return response;
  },
  verifyPhoneNumber: async (verificationNumber) => {
    var response = await httpSmartClient.post(`/${baseName}/VerifyPhoneNumber?verificationNumber=${verificationNumber}`);
    return response;
  },
};
export default AuthService;
